import React, { Component } from "react";
import { View, Image, TouchableOpacity, AppState,ScrollView } from 'react-native'
import { icons } from "../theme/icons";
import { appStyles, componentStyles, walletStyles } from '../theme/styles'
import TextView from "../components/TextView";
import LinearGradient from 'react-native-linear-gradient';
import { blueDarkColor, blueLightColor, greenDarkColor, greenLightColor } from "../theme/colors";
import { walletInfoRequest, walletChargeRequest } from "../utils/api";
import DialogMessage from "../components/DialogMessage";
import Waiting from "../components/Waiting";
import { inject, observer } from "mobx-react";
import { wp, hp } from "../utils/responsive";
import TextInput from "../components/TextInput/TextInput";
import { showMessage, getError, priceString } from "../utils/utils";

var theme = {
    colors: {
        text: 'black',
        error: 'red',
        primary: '#000000cc',
        outlineColor: '#eeeeee',
        placeholder: 'gray'
    }
}
@inject('store')
@observer
export default class WalletScreen extends Component {
    constructor(props) {
        super(props)
        this.state = {
            amount: 0,
            price: '',
            gotopay: false,
            appState: '',
            waiting: false,
            showMessage: false,
            messageTitle: '',
            messageContent: '',
            messageSucces: false
        }
    }

    render() {
        return (<View style={appStyles.flex1}>
            <View style={appStyles.toolbarWraper}>
                <Image source={icons['ad']} style={[appStyles.toolbarIcon, { tintColor: '#31BFCF' }]} />
                <TextView style={appStyles.toolbarTitle}>کیف پول آد</TextView>
                <TouchableOpacity onPress={() => {
                    this.props.navigation.goBack()
                }}>
                    <Image source={icons['back']} style={appStyles.backIcon} />
                </TouchableOpacity>
            </View>
            <LinearGradient colors={[blueDarkColor, blueLightColor]} style={walletStyles.wraper}>
                <ScrollView contentContainerStyle={[{ width: wp(100), flex: 1, justifyContent: 'center', alignItems: 'center' }, appStyles.center]} enableOnAndroid={true} keyboardShouldPersistTaps='handled'>

                    <View style={walletStyles.walletBox}>

                        <View style={[appStyles.boxWraper]}>
                            <TextView>موجودی کیف پول</TextView>
                            <TextView style={{ color: blueDarkColor, fontSize: 24 }}>{priceString(this.props.store.wallet_amount)}</TextView>
                            <TextView>هزار تومان</TextView>
                            <TextInput
                                placeholder='مبلغ به تومان وارد شود'
                                mode='outlined'
                                inputType='numeric'
                                theme={theme}
                                returnKeyType={'done'}
                                onSubmitEditing={() => { }}
                                wrapperStyle={{ width: wp(60) }}
                                onChangeText={(text) => {
                                    this.setState({
                                        price: text
                                    })
                                }}
                                value={this.state.price}
                            />
                            <TouchableOpacity style={{ alignSelf: 'center', margin: 20 }} activeOpacity={0.5} onPress={() => {
                                if (this.state.price.length > 0) {
                                    this.setState({
                                        waiting: true
                                    })
                                    walletChargeRequest(this.state.price, (isConnect, response) => {
                                        this.setState({
                                            waiting: false
                                        })
                                        if (isConnect && response.isSuccess) {
                                            var url = response.data.url_pay;
                                            if (!/^https?:\/\//i.test(url)) {
                                                url = 'http://' + url;
                                            }
                                            this.setState({
                                                gotopay: true
                                            })
                                            window.open(url,'_blank')
                                        } else {
                                            showMessage('', getError(response))
                                        }
                                    })
                                }
                            }}>
                                <LinearGradient start={{ x: 0, y: 0 }} end={{ x: 1, y: 0 }} colors={[greenDarkColor, greenLightColor]} style={[componentStyles.gradinatButton, { width: 150, height: 50, borderRadius: 25 }]}>
                                    <TextView style={{ color: 'white' }}>شارژ حساب</TextView>
                                </LinearGradient>
                            </TouchableOpacity>
                        </View>
                        <View style={walletStyles.diamondWraper}>
                            <Image source={icons['wallet']} style={[appStyles.toolbarIcon, { tintColor: blueDarkColor }]} />
                        </View>
                    </View>
                </ScrollView>
            </LinearGradient>
            <Waiting waiting={this.state.waiting} />
            <DialogMessage
                show={this.state.showMessage}
                title={this.state.messageTitle}
                message={this.state.messageContent}
                onClose={() => {
                    this.setState({
                        showMessage: false
                    })
                }} />
        </View>)
    }

    componentWillMount() {
        this.getAmount()
    }
    getAmount() {
        this.setState({
            waiting: true
        })
        walletInfoRequest((isConnect, response) => {
            this.setState({
                waiting: false
            })
            if (isConnect && response.isSuccess) {
                this.setState({
                    amount: response.data.sharge
                })
                this.props.store.changeWalletAmount(response.data.sharge);
            }
        })
    }

    componentDidMount() {
        AppState.addEventListener('change', this._handleAppStateChange);
    }
    componentWillUnmount() {
        AppState.removeEventListener('change', this._handleAppStateChange);
    }
    _handleAppStateChange = (nextAppState) => {
        if (this.state.appState.match(/inactive|background/) && nextAppState === 'active') {
            if (this.state.gotopay) {

                this.setState({
                    gotopay: false
                })
                this.getAmount()
            }

        }

        this.setState({ appState: nextAppState });
    }


}
